import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TGetSshKeyRotationPublicKeyResponseSchema } from "./getSshKeyRotationPublicKey.schema";

export const getSshKeyRotationPublicKey = (axios: IAxiosInstance) => {
  return async (sshKeyRotationId: string) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetSshKeyRotationPublicKeyResponseSchema>
    >(`/api/sshKeyRotations/${sshKeyRotationId}/publicKey`);

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
